export default __webpack_public_path__ + "static/race-mobile-465248cb1d88353d23bb6b11db7e5b24.webm";